import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f94148"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "message" }

import { useRouter } from 'vue-router'
import { ref, watchEffect } from 'vue'

import LoadingIcon from '@/assets/loading.svg'
import SuccessIcon from '@/assets/success.svg'
import ErrorIcon from '@/assets/error-white.svg'
import { PopupDatabase } from '@/popup/storage/Database'

type Props = {
  messageIcon: string
  message: string
  background: string
  id?: string
  path?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Toaster',
  props: {
    messageIcon: { default: 'loading' },
    message: { default: '' },
    background: { default: '' },
    id: { default: undefined },
    path: { default: undefined }
  },
  setup(__props: any) {

const props = __props

const icons: { [key: string]: string } = {
  loading: LoadingIcon,
  success: SuccessIcon,
  warning: LoadingIcon,
  error: ErrorIcon,
}

const router = useRouter()
const requestId = ref<string>()

const onClick = async () => {
  if (props.path) {
    return await router.push(props.path)
  }

  if (requestId.value) {
    return await router.push({
      name: 'activityDetail',
      params: { txId: requestId.value },
    })
  }
}

watchEffect(async () => {
  if (props.id) {
    const { requestId: _requestId } =
      (await PopupDatabase.getTransactionByRequestId(props.id)) || {}
    requestId.value = _requestId
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`toaster ${_ctx.background} ${requestId.value || _ctx.path ? 'clickable' : ''}`),
    onClick: onClick,
    "data-testid": "toaster"
  }, [
    _createElementVNode("img", {
      src: icons[_ctx.messageIcon],
      class: "message-icon"
    }, null, 8 /* PROPS */, _hoisted_1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.message), 1 /* TEXT */)
  ], 2 /* CLASS */))
}
}

})